import {NgModule} from '@angular/core';
import {WizardComponent} from './wizard.component';
import {OrganizationContactsFieldsComponent} from './fields/organization/organization-contacts.component';
import {OrganizationBankFieldsComponent} from './fields/organization/organization-bank.component';
import {OrganizationLegalFieldsComponent} from './fields/organization/organization-legal.component';
import {OrganizationCommonComponent} from './fields/organization/organization-common.component';
import {FormsModule} from '@angular/forms';
import {LaboratoryTypeFieldsComponent} from './fields/laboratory/laboratory-type.component';
import {LaboratoryOwnerFieldsComponent} from './fields/laboratory/laboratory-owner.component';
import {LaboratoryCommonFieldsComponent} from './fields/laboratory/laboratory-common.component';
import {ResponsibleStaffFieldsComponent} from './fields/specialist/responsible-staff.component';
import {WizardConclusionsFieldsComponent} from './fields/wizard/wizard-conclusions.component';
import {WizardResultFiledsComponent} from './fields/wizard/wizard-result.component';
import {Select2Module} from 'ng2-select2';
import {ComplianceTableComponent} from './components/compliance-table/compliance-table.component';
import {FormHelperService} from '@services/form-helper.service';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {WizardNavigationComponent} from './components/wizard-navigation/wizard-navigation.component';
import {CertificateNkModule} from '@subforms/certificates/nk.module';
import {CertificatePbModule} from '@subforms/certificates/pb.module';
import {AccordionModule} from '@components/accordion/accordion.module';
import {CollapseLinkModule} from '@components/collapse-link/collapse-link.module';
import {ObjectsModalSelectModule} from '@components/objects-modal-select/objects-modal-select.module';
import {AddressFieldsModule} from '@subforms/address-fields/address-fields.module';

import {WizardDataResolverService} from './services/wizard-data-resolver.service';
import {WizardService} from './services/wizard.service';
import {SharedModule} from '@helpers/modules/shared.module';
import {BankFieldsModule} from '@subforms/bank-fields/bank-fields.module';
import {AnchorNavigationComponent} from './components/anchor-navigation/anchor-navigation.component';
import {ThankYouComponent} from './fields/thank-you/thank-you.component';
import {WizardStepComponent} from './components/wizard-step.component';
import {AttestationComponent} from './fields/attestation/attestation.component';
import {AttestationMethodComponent} from './fields/attestation/attestation-method.component';
import {LaboratoryStaffComponent} from './fields/laboratory-staff/laboratory-staff.component';
import {EquipmentComponent} from './fields/equipment/equipment.component';
import {EquipmentModalModule} from './fields/equipment/modal/equipment-modal.module';
import {EquipmentGroupPreviewModule} from './fields/equipment/equipment-group-preview/equipment-group-preview.module';
import {EquipmentGroupsSummaryComponent} from './fields/equipment/equipment-groups-summary/equipment-groups-summary.component';
import {StdModule} from './fields/std/std.module';
import {StaffListModule} from './fields/laboratory-staff/staff-list/staff-list.module';
import {WizardContentComponent} from './components/wizard-content.component';
import {LaboratoryDocumentsModule} from '@components/laboratory-documents/laboratory-documents.module';
import {SpecialistsModule} from '@modules/specialists/specialists.module';
import {IconsModule} from '@lab365/icons';
import {Lab365CommonModule} from '@lab365/common';

@NgModule({
    declarations: [
        /**
         * Комопненты самого визарда
         */
        WizardComponent,
        WizardStepComponent,
        WizardNavigationComponent,
        WizardContentComponent,
        AnchorNavigationComponent,

        /**
         * Компоненты для UI шагов визарда
         */
        OrganizationContactsFieldsComponent,
        OrganizationBankFieldsComponent,
        OrganizationLegalFieldsComponent,
        OrganizationCommonComponent,
        LaboratoryTypeFieldsComponent,
        LaboratoryOwnerFieldsComponent,
        LaboratoryCommonFieldsComponent,
        LaboratoryStaffComponent,
        AttestationComponent,
        ResponsibleStaffFieldsComponent,
        EquipmentComponent,
        WizardConclusionsFieldsComponent,
        WizardResultFiledsComponent,
        ThankYouComponent,

        /**
         * Компоненты, используемые в шагах визарда
         */
        ComplianceTableComponent,
        AttestationMethodComponent,
        EquipmentGroupsSummaryComponent,
    ],
    exports: [
        WizardComponent
    ],
    imports: [
        SharedModule,
        FormsModule,
        CertificateNkModule,
        CertificatePbModule,
        AccordionModule,
        CollapseLinkModule,
        Select2Module,
        ObjectsModalSelectModule,
        AddressFieldsModule,
        DirectivesModule,
        BankFieldsModule,
        LaboratoryDocumentsModule,
        SpecialistsModule,

        /**
         * Некоторые компоненты и шаги визарда
         * используются как модули, чтобы
         * инкапсулировать в себе всю логику
         */
        EquipmentModalModule,
        EquipmentGroupPreviewModule,
        StdModule,
        StaffListModule,
        IconsModule,
        Lab365CommonModule,
    ],
    providers: [
        FormHelperService,
        WizardService,
        WizardDataResolverService,
    ]
})
export class WizardModule {}
